export default __webpack_public_path__ + "static/media/section2_1.cf58fe24.svg";